import http from '../api'
import { CategoryDTO, FileDTO } from './types'

async function getFiles() {
  return await http.get<FileDTO[]>('files')
}

async function getCategories() {
  return await http.get<CategoryDTO[]>('files/categories')
}

async function deleteFile(id: number) {
  return await http.delete<boolean>(`files/${id}`)
}

async function createFile(input: FormData) {
  return await http.post<FileDTO>('files', input)
}

async function updateFile(id: number, input: FormData) {
  return await http.patch<FileDTO>(`files/${id}`, input)
}

export default {
  getFiles,
  getCategories,
  createFile,
  updateFile,
  deleteFile,
}
